import * as Yup from "yup";
const TRANSLATION_BASE_PATH = "_COURSE_BUILDER._BUILD_MATERIALS._LESSON_MATERIAL";

export const formValidator = (translate: (key: string) => string) =>
	Yup.object({
		startDate: Yup.string()
			.required(translate(`${TRANSLATION_BASE_PATH}._REQUIRED`))
			.nullable()
	});
